/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: '홈',
	homePageTabsLabel: '홈 컨텐츠',
	myContent: '내 컨텐츠',
	teamContent: '팀 컨텐츠',
	folder: '폴더',
	files: '파일',
	actionMenu: '동작 메뉴',
	myFolder: '내 폴더',

	emptyFolderNoContent: '컨텐츠 없음',

	//EmptyStates
	emptyRecentTitle: '최근에 컨텐츠를 보지 않았습니다.',
	emptyStateTitle: '데이터를 추가하여 시작',
	emptyStateBody: '위에 있는 데이터 업로드를 클릭하거나, 끌어서 놓아 데이터를 업로드하십시오.',
	emptySearchResultTitle: '검색에서 결과를 리턴하지 않았습니다.',
	emptyPortalTitle: '포털 없음',
	emptyPortalBody: '현재 포털이 없습니다.',
	emptyWsProjectTitle: '먼저 Watson Studio에서 노트북을 작성하십시오.',
	emptyWsProjectBody: 'Cognos Analytics로 돌아가면 노트북이 여기에 표시됩니다.',
	emptyFilteredResultTitle: '적용된 필터에서 결과를 리턴하지 않았습니다.',
	emptyDialogViewTitle: '항목 없음',
	removeFromRecents: '최근에서 제거',

	// Welcome Banner
	welcomeBannerGreeting: '안녕하세요. Cognos Analytics with Watson에 오신 것을 환영합니다.',
	welcomeBannerDescription: 'Cognos Analytics with Watson은 AI 기반 셀프 서비스 분석을 통해 사용자에게 권한을 부여합니다. 자동화된 데이터 준비, 데이터 검색 및 시각화가 어떻게 보다 확실한 의사결정을 내릴 수 있게 해 주는지 알아보십시오.',
	welcomeBannerDescription_trialUser: '소개 비디오, 제품 둘러보기 및 시작하기 탭만 살펴보고 나면 바로 사용을 시작할 수 있습니다.',
	takeTourButtonLabel: '제품 둘러보기',
	watchVideoButtonLabel: '비디오 보기',
	// confirmation dialog
	hideWelcomeBannerMsg: '홈 페이지에서 환영 배너를 끄시겠습니까? 이는 언제든지 프로파일 및 설정 > 설정 > 일반에서 다시 켤 수 있습니다. ',
	hideWelcomeBannerTitle: '환영 배너 끄기',
	ok: '확인',
	cancel: '취소',
	warn: '경고',
	//howto video dialog
	modal_how_title: 'Cognos Analytics 개요 보기',
	modal_overview_title: 'Cognos Analytics 개요 보기',
	modal_how_play: '비디오 재생',
	modal_how_video_title_overview: '개요',
	modal_how_video_title_getStarted: '11.2 시작하기',
	modal_how_video_title_newUI: '새로운 Cognos 경험을 시작합니다.',
	modal_how_video_title_dataModule: '데이터 모듈 개요',
	modal_how_video_title_explore: '데이터 탐색 개요',
	modal_how_video_title_dashboard: '대화식 대시보드 개요',
	modal_how_video_title_reporting: '보고 개요',
	modal_how_video_title_mobile: '손 안에 있는 Cognos의 강력함',

	// Toolbar
	search: '검색',
	addFolder: '폴더 추가',
	addLink: '링크 추가',
	filter: '필터',
	sort: '정렬',
	settings: '설정',
	tilesView: '바둑판식 보기',
	listView: '목록 보기',
	columnView: '열 보기',
	backToSearch: '검색 결과로 돌아가기',

	// Toolbar Actions
	sortBy: '정렬 기준',
	sortOrder: '순서',
	name: '이름',
	modifiedTime: '수정됨',
	type: '유형',
	ascending: '오름차순',
	descending: '내림차순',
	resetSort: '정렬 재설정',

	filterType: '유형',
	filterModificationTime: '수정됨',
	all: '모두',
	today: '오늘',
	yesterday: '어제',
	pastWeek: '지난 주',
	pastMonth: '지난 달',
	resetFilters: '필터 재설정',
	resultLimit: '결과 한계',

	filterSearchPlaceHolder: '키워드로 필터링',

	resetFilterTag: '필터를 재설정하려면 X를 클릭합니다.',
	filterTagToolTip: '적용된 필터: %{appliedFilters}.',

	folderName: '폴더 이름',
	addAFolder: '폴더 추가',
	add: '추가',
	error: '오류',
	newFolderDefaultName: '새 폴더',
	toastCreateNewFolder: '%{nameOfFolder} 폴더가 %{tabName}에 작성되었습니다.',
	folderAdded: '폴더가 추가됨',
	refresh: '새로 고치기',
	openFolder: '폴더 열기',

	addAUrl: 'URL 추가',
	linkName: 'URL 이름',
	linkNamePlaceholder: 'URL 이름 추가',
	linkDescription: '설명(선택사항)',
	linkDescriptionPlaceholder: '설명 추가',
	linkUri: 'URL',
	linkUriPlaceholder: '허용되는 도메인을 사용하는 URL 추가',
	acceptableDomains: '허용되는 도메인',
	viewAcceptableDomains: '허용되는 도메인 보기',
	mandatoryField: '필수 필드',
	linkAdded: 'URL이 추가됨',
	toastCreateNewLink: '%{nameOfLink}이(가) %{tabName}에 추가되었습니다.',
	noEntries: '허용되는 도메인 목록에 항목이 없습니다. 관리자에게 문의하십시오.',
	unacceptableDomain: 'URL이 올바르지 않은 도메인을 사용하고 있습니다. 사용할 수 있는 도메인 목록을 보려면 \'허용되는 도메인 보기\'를 클릭하십시오.',

	compact: '압축',
	short: '짧음',
	default: '기본값',
	rowSize: '행 크기',

	// GroupyByTypes
	folders: '폴더',
	reports: '보고서',
	dashboards: '대시보드',
	data: '데이터',
	packages: '패키지',
	explorations: '탐색',
	stories: '스토리',
	notebooks: '노트북',
	others: '기타',

	// Error Messages
	itemsOverLimit: '지정된 이름 "%{itemName}"이(가) 최대값(20) 한계를 초과했습니다. 계속하려면 다른 이름을 지정하십시오.',
	errorMessageLengthFolderName: '255자를 초과하지 않는 폴더 이름을 입력하십시오.',
	errorMessageLengthLinkName: '255자를 초과하지 않는 링크 이름을 입력하십시오.',
	toastLaunchPerspectiveError: '%{objectType}을(를) 열 수 없습니다.',
	errorNoAccessTitle: '이 컨텐츠에 대한 액세스 권한이 없는 것 같습니다.',
	errorNoAccessBody: '관리자에게 문의하거나 다음 링크를 참조하십시오.',
	errorEnableExternalContent: '외부 컨텐츠 사용',

	//TableHeader
	lastAccessed: '마지막 액세스',
	location: '위치',
	tenant: '테넌트',

	// GetStartedTab
	getStartedLabel: 'IBM Cognos Analytics 시작 및 실행',
	learningHowToLabel: '학습 자원',
	learningHowToDescription: '커뮤니티와 연결하고 문서를 읽고 비디오를 시청하여 지식을 넓히고 도움을 받으십시오.',
	learningHowToActionLabel: '학습 창 시작',
	howToVideosLabel: '방법 비디오',
	howToVideosDescription: 'IBM Cognos Analytics 사용법을 학습하고 사용자 데이터에 대한 인사이트를 얻으십시오.',
	howToVideosActionLabel: '비디오 보기',
	acceleratorCatalogLabel: 'Accelerator 카탈로그',
	acceleratorCatalogDescription: '업계의 기법, 우수 사례 안내서, 사용자 정의 시각화 등에 대한 계속해서 확장되는 카탈로그를 탐색하십시오.',
	acceleratorCatalogActionLabel: '카탈로그 탐색',
	sampleSectionTitle: '샘플',
	sampleSectionDescription: 'Cognos Analytics에서 제공하는 모든 것을 보여주는 예를 마음대로 사용해 보십시오.',
	// Samples Section
	createDashboardSampleTitle: '첫 번째 대시보드를 작성하는 방법',
	createDashboardSampleDescription: 'Cognos Dashboard와 함께 분석 작업을 시작해 보십시오.',
	nlaSampleTitle: '샘플 보고서',
	nlaSampleDescription: '연말 로열티 카드 회원 활동을 분석하는 이 예제를 참조하여 Cognos Analytics 보고서에서 볼 수 있는 내용을 탐색하십시오.',
	sankeySampleTitle: '생키',
	sankeySampleDescription: '생키 차트와 같은 사용자 정의 시각화를 사용하여 시각화 라이브러리를 확장하십시오.',
	viewAllSamplesActionLabel: '모든 샘플 보기',
	byFeatureTitle: '기능별',
	byFeatureDescription: '핵심 기능, 사용자 정의 제어, 확장, 노트북 및 관련 날짜와 같은 기능별로 샘플을 찾아볼 수 있습니다. ',
	byIndustryTitle: '업종별',
	byIndustryDescription: '자동차, 은행 등과 같은 업종별 샘플을 찾아볼 수 있습니다. ',
	// SamplesTab
	sampleTabTitle: '사전 빌드된 샘플에서 영감 얻기',
	sampleTabLabel: 'IBM, 파트너, 고객의 샘플과 확장 기능을 보려면 Accelerator 카탈로그를 방문하십시오. ',

	// quickLaunch
	quickLaunchLabel: '빠른 시작',
	expand: '펼치기',
	collapse: '접기',

	// quickLaunch dialog
	quickLaunchModalLabel: '먼저 작성할 항목을 선택하십시오.',

	// contentPageView
	contentPageTitleLabel: '컨텐츠',
	uploadFile: '데이터 업로드',
	new: '새로 작성',
	create: '작성',
	more: '자세히',

	// open dialog
	selectDataSourcesToAdd: '추가할 데이터 소스를 선택하십시오.',
	openDialogDefaultTitle: '열기',

	// save dialog
	save: '저장',
	saveAs: '다른 이름으로 저장',
	saving: '저장 중...',
	selectedDestination: '선택한 대상: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '다른 유형의 \'%{nameOfItem}\'이(가) 이미 있습니다. 다른 이름을 선택하십시오.',
	confirmOverwriteTitle: '기존 데이터 대체 확인',
	confirmOverwriteMsg: '\'%{nameOfFile}\' 파일이 이미 있습니다. 해당 데이터를 선택한 파일에 포함된 데이터로 바꾸시겠습니까?',

	// copy move dialog
	copy: '복사',
	move: '이동',
	copyOrMove: '복사 또는 이동: ',
	copyOnly: '복사 ',
	createShortcut: '바로 가기 작성',
	createShortcutDialogTitle: '바로 가기 작성: ',

	// External asset types
	wsProject: 'Watson Studio 프로젝트',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: '패키지',
	dataModule: '데이터 모듈',
	exploration: '탐색',
	mode: '모드',
	live: '라이브',
	snapshot: '스냅샷',
	noSnapshotsFound: '스냅샷을 찾을 수 없음',
	uploadedFile: '업로드된 파일',
	fileUpload: '데이터 업로드',
	dataSetEx: '데이터 세트',
	externalRepository: '외부 리포지토리',
	queryMode: '쿼리 모드',
	queryModeCompatible: '호환 가능',
	queryModeDynamic: '동적',
	report: '보고서',
	activeReport: '활성 보고서',
	query: '쿼리',
	analysis: '분석',
	dashboard: '대시보드',
	dashboardTemplate: '대시보드 템플리트',
	jupyterNotebook: '노트북',
	wsNotebook: 'Watson Studio 노트북',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: '스토리',
	workspace: '작업공간',
	pagelet: '페이지',
	content: '컨텐츠',
	directory: '네임스페이스',
	dataSet: '데이터 세트',
	powerPlayCube: 'PowerPlay 큐브',
	powerPlayReport: 'PowerPlay 보고서',
	powerPlay8Report: 'PowerPlay 보고서',
	setPowerPlay8ReportOptions: 'PowerPlay 보고서 옵션 설정',
	powerPlay8ReportView: 'PowerPlay 보고서 뷰',
	reportTemplate: '보고서 템플리트',
	packageConfigurations: '패키지 구성',
	agent: '에이전트',
	agentDefinition: '에이전트 정의',
	agentDefinitionView: '에이전트 보기',
	dataMovementTask: '데이터 이동 작업',
	dataMovementTaskAlias: '데이터 이동 작업 별칭',
	document: '문서',
	DocumentRetention: '문서 특성',
	jobDefinition: '작업 정의',
	job: '작업',
	jobs: '직업',
	metricsDataSourceETLTask: '메트릭 데이터 소스 ETL 작업',
	metricsExportTask: '메트릭 내보내기 작업',
	metricsFileImportTask: '메트릭 파일 가져오기 작업',
	metricsMaintenanceTask: '메트릭 유지보수 작업',
	planningTask: 'Planning 작업',
	shortcut: '바로 가기',
	shortcuts: '바로 가기',
	URL: 'URL',
	launchable: '시작 가능',
	dataSetFolder: '데이터 세트 폴더',
	ViewAccessibleLabel: '%{label} 보기',
	overrideReportOptions: '기본 보고서 옵션 대체',
	formats: '형식',
	saveReport: '보고서 저장',
	reportView: '보고서 뷰',
	reportviews: '보고서 뷰',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel 데이터',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: '역할',
	namespace: '네임스페이스',
	namespaceFolder: '네임스페이스 폴더',
	adminFolder: '관리 폴더',
	//Details
	details: '세부사항',
	open: '열기',
	created: '작성됨',
	modified: '수정됨',
	owner: '소유자',
	dataSource: '데이터 소스',
	share: '공유',
	addToFavorites: '즐겨찾기에 추가',
	properties: '특성',
	detailsEmptyStateBody: '세부사항을 확인할 항목 선택',
	editNameAndDescription: '이름 및 설명 편집',
	none: '없음',
	setPdfOptions: 'PDF 옵션 설정',
	runOptions: '실행 옵션',

	//rename dialog
	nameInvalid: '이름이 올바르지 않음',
	namePlaceholder: '이름 입력',
	description: '설명',
	descriptionInvalid: '이 설명은 350자를 초과할 수 없습니다. ',
	descriptionPlaceholder: '설명 입력',
	errorMessageApostropheError: '\' 및 " 문자를 모두 포함하지 않는 파일 이름을 입력하십시오.',
	renameCollisionError: '%{name}이(가) 이미 존재합니다. 다른 이름을 사용하십시오.',
	unknownRenameError: '항목 이름 바꾸기에 실패했습니다. 추가 지원은 관리자에게 문의하십시오.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: '지정된 폴더를 열 수 없습니다.',

	//Upload
	uploadToFolder: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}에 업로드",
	uploadAndLaunch: "<span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>에 업로드하고 %{launchAction} 시작",
	quickUpload: "빠른 업로드",
	quickUploadAndLaunch: "파일을 끌어서 놓아 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>에 업로드하고 다음 공간 중 하나에서 여십시오.",
	unsupportedFilesSingle: "%{files}이(가) 빠른 시작에 대해 올바르지 않아 업로드되지 않았습니다.",
	unsupportedFilesMultiple: "선택한 모든 파일이 올바른 경우에만 빠른 시작을 사용할 수 있으므로 파일이 업로드되지 않았습니다.",
	unsupportedFilesSingleInvalid: "%{files}이(가) 올바르지 않습니다.",
	unsupportedFilesMultipleInvalid: "%{files}이(가) 올바르지 않습니다.",
	supportedFileTypes: "다음 파일 유형만 허용됩니다: %{extensions}.",
	uploadDragAndDrop: "끌어서 놓기",
	uploadDragAndDropMessage: "파일을 여기로 끌어서 놓아 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>에 업로드하십시오.",

	// searchBar
	searchWasSaved: '검색 기준 \'%{searchTerm}\'이(가) 저장되었습니다.',
	searchWasntSaved: '검색 기준 \'%{searchTerm}\'이(가) 저장되지 않았습니다.',
	searchSuggestions: '제안사항',
	savedSearch: '저장한 검색',
	searchWasDeleted: '검색 기준 \'%{searchTerm}\'이(가) 삭제되었습니다.',
	searchWasntDeleted: '검색 기준 \'%{searchTerm}\'이(가) 삭제되지 않았습니다.',
	savedBarTitle: 'Cognos Analytics 검색',
	searchContentPageTitle: '검색',
	searchContentPageTitleLabel: '\'%{searchTerm}\' 결과 표시',
	showingSearchRsult: '%{resultCount}개 항목 표시',
	saveSearch: '검색 저장',
	saveTenSearches: '10번의 검색을 저장할 수 있습니다.',
	deleteASearch: '다른 항목을 저장하려면 항목 하나를 삭제하십시오.',
	close: '닫기',
	allContent: '모든 컨텐츠',
	searchResultIn: '검색 결과: ',
	//recent view
	recents: '최근',
	noAccessRecent: '액세스 권한 없음',
	noAccessRecentMsg: '이 자산에 대한 액세스 권한이 없습니다. 사용 안함으로 설정되어 있거나 삭제되었거나 권한이 축소되었을 수 있습니다. 예상 소스 위치에서 자산 상태를 확인하십시오. 확인을 클릭하여 최신 항목에서 자산을 제거할 수 있습니다.',
	noAccessMsg: '이 자산에 대한 액세스 권한이 없습니다. 사용 안함으로 설정되어 있거나 삭제되었거나 권한이 축소되었을 수 있습니다.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection}개 항목이 선택됨',
	itemSelected: '%{nameOfSelection}개 항목이 선택됨',

	//properties
	general: '일반',
	schedule: '스케줄',
	permission: '권한',
	capabilities: '기능',
	propertiesTabsLabel: '특성 컨텐츠',
	searchPath: '검색 경로',
	id: 'ID',
	language: '언어',
	setLanguage: '언어 설정',
	entryOptions: '입력 옵션',
	setPackage: '패키지 또는 모듈 설정',
	sourcePackage: '소스 패키지 또는 데이터 모듈',
	associatedSourceAgent: '소스 패키지',
	setAssociatedSourceAgent: '패키지 설정',
	sourceAgent: '소스 에이전트',
	setSourceAgent: '소스 에이전트 설정',
	setCapabilities: '기능 설정',
	disableEntry: '이 항목 사용 안함',
	hideEntry: '이 항목 숨기기',
	permissions: '권한',
	promptForValues: '값에 대한 프롬프트',
	yes: '예',
	no: '아니오',
	setValues: '값 설정',
	moreOptions: '추가 옵션',
	reportFormat: '보고서 형식',
	enableAccessibilitySupport: '내게 필요한 옵션 지원 사용',
	displayOfRunHistory: '실행 히스토리 표시',
	occurrences: '발생 횟수',
	days: '일',
	months: '월',
	displayOfReportOutputVersions: '보고서 출력 버전 표시',
	defaultDisplayOfPortalAction: '기본 포털 조치',
	viewMostRecentReport: '최근 보고서 보기',
	runTheReport: '보고서 실행',
	openWithReportStudio: 'Report Studio에서 열기',
	rowsPerPageInHtmlReports: 'HTML 보고서의 페이지당 행 수',
	enableSelectionBasedInteractivity: '선택 기반 대화식 작업 사용',
	enableAlertsAboutNewVersions: '새 버전에 대한 경보 사용',
	enableEnhancedUserFeaturesInSavedOutputVersions: '저장된 출력 버전에서 향상된 사용자 기능 사용',
	enableCommentsInSavedOutputVersions: '저장된 출력 버전에서 주석 사용',
	run: '실행',
	runWithUsersCredentials: '사용자의 신임 정보 사용',
	runWithOwnerCapabilities: '소유자 기능 사용',
	runAsOwner: '%{ownerName}(으)로 실행',
	actionLabelOn: '켜기',
	actionLabelOff: '해제',
	openReport: '편집',
	openAnalysis: 'Analysis Studio에서 열기',
	openQuery: 'Query Studio에서 열기',
	openPowerPlay8Report: 'PowerPlay Studio에서 열기',
	openInteractiveReport: '편집',
	read: '읽기',
	write: '쓰기',
	execute: '실행',
	setPolicy: '정책 설정',
	full: '전체',
	traverse: '순회',
	grant: '권한 부여',
	deny: '거부',
	permissionCustom: '사용자 정의',
	permissionDetailsColumnAccess: '액세스',
	permissionDetailsColumnPermission: '권한',
	permissionDetailsColumnAction: '조치',
	permissionSetAccess: '액세스 설정',
	permissionRead: '읽기',
	permissionRun: '다음을 실행하십시오.',
	permissionWrite: '쓰기',
	permissionFull: '전체',
	unavailable: '사용 불가능',
	unkownSource: '알 수 없음, 세부사항에 대한 보고서 열기',
	tenantSettings: '테넌트 설정',
	tenantSet: '테넌트가 업데이트됨',
	tenantSetError: '테넌트 설정 중 오류 발생',
	tenantClear: '테넌트가 선택 취소됨',
	tenantClearError: '테넌트 선택 취소 중 오류 발생',
	shortcutTo: '바로 가기',
	sourceReport: '소스 보고서',
	setSourceReport: '소스 보고서 설정',
	setSourceLocation: '소스 %{itemName} 위치 설정',
	linkPackageOrModule: '%{itemName}을(를) 패키지 또는 데이터 모듈에 링크하십시오.',
	linkPackage: '%{itemName}을(를) 패키지에 링크하십시오.',
	externalRepositories: '외부 저장소',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value}KB',
	sizeMegaByte: '%{value}MB',
	sizeGigaByte: '%{value}GB',
	sizeTeraByte: '%{value}TB',
	sizePetaByte: '%{value}PB',
	refreshedDatetime: '새로 고치기 시간',
	size: '크기',
	tenantsWarningMessage: '또한 항목의 테넌트를 변경하면 하위 항목의 테넌트도 변경됩니다.',
	confirmClearTenantText: '값을 \'없음\'으로 지우면 다른 테넌트가 컨텐츠에 액세스할 수 있습니다. 항목을 공용으로 만들려면 확인을 클릭하고 현재 테넌트를 유지하려면 취소를 클릭하십시오.',
	confirmClearTenant: '테넌트 선택 취소 확인',
	currentValues: '현재 값',
	emptyPromptValues: '현재 값이 없음',
	editValues: '값 편집',
	clear: '지우기',
	source: '소스',
	dataRefreshed: '데이터 새로 고침',
	//PDF options
	pdfOptions: 'PDF 옵션',
	set: '세트',
	portrait: '세로',
	landscape: '가로',
	letter: '문자',
	legal: '법률',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: '방향',
	pageDefination: '용지 크기',
	openPasswordRequired: '보고서를 여는 데 비밀번호가 필요합니다.',
	accessPasswordRequired: '보고서에 액세스하려면 비밀번호가 필요합니다.',
	emptyPassword: '비밀번호는 비워둘 수 없습니다.',
	password: '비밀번호',
	enterPassword: '비밀번호 입력',
	confirmPassword: '비밀번호 확인',
	passwordMatchError: '비밀번호가 일치하지 않음',
	gateway: '게이트웨이',
	pageLayout: '페이지 레이아웃',
	pageStyle: '스타일',
	setUrl: 'URL 설정',
	numberRows: '행 수',
	numberColumns: '열 수',
	timeToRefresh: '새로 고치기 시간',
	lastRefreshedBy: '새로 고친 사용자',
	unknown: '알 수 없음',
	unknownUpdateError: '항목 업데이트에 실패했습니다. 추가 지원은 관리자에게 문의하십시오.',
	editQuery: '쿼리 편집',
	greaterOrEqual: '%{upperboundValue}에 대해 크거나 같음',
	lessOrEqual: '%{lowerboundValue}에 대해 작거나 같음'
});
